import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import { requiredValidator } from "@entrilia/shared/utilities/validators";
import type { EntityFieldType } from "../../../../../api/types/objectTypes";

export interface WorkflowTemplateActivityFieldFormState {
  displayName: string;
  type: EntityFieldType;
  description: string;
  isRequired: boolean;
}

export interface WorkflowTemplateActivityFieldFormValidationResults {
  displayName: ValidationResult;
  description: ValidationResult;
  isValid: boolean;
}

export type WorkflowTemplateActivityFieldFormTouchedField = "displayName" | "description";
export type WorkflowTemplateActivityFieldFormTouchedFields = Partial<
  Record<WorkflowTemplateActivityFieldFormTouchedField, boolean>
>;

export const validateWorkflowTemplateActivityFieldForm = (
  formState: WorkflowTemplateActivityFieldFormState
): WorkflowTemplateActivityFieldFormValidationResults => {
  const displayName = requiredValidator(formState.displayName);
  const description = requiredValidator(formState.description);
  const isValid = displayName.isValid && description.isValid;
  return {
    displayName,
    description,
    isValid,
  };
};
